export default __webpack_public_path__ + "static/B0113-bcc4e143ecd5f2519b26b10da058b930.png";